export default __webpack_public_path__ + "static/image-52-8440861e2b2e4e2945e46dbb1b05d00f.jpg";